// extracted by mini-css-extract-plugin
export var card = "card-module--card--TTLUX";